import { call, fork, put, takeEvery } from 'redux-saga/effects';

import {
  CREATE_CASE_FROM_ALERT,
  createCaseFromAlertSuccess,
  createCaseFromAlertFail
} from '../../redux/actions/cm/convertAlertsToCase';

import { createCaseFromAlerts } from '../../services/cm/alerts';

function* createCaseFromAlert({ alertIds, departmentId }) {
  try {
    const { caseId } = yield call(createCaseFromAlerts, {
      alertIds,
      departmentId
    });
    yield put(createCaseFromAlertSuccess({ caseId }));
  } catch (error) {
    yield put(createCaseFromAlertFail(error));
  }
}

export function* watchCreateCaseFromAlert() {
  yield takeEvery(
    CREATE_CASE_FROM_ALERT,
    function* ({ payload: { alertIds, departmentId } }) {
      yield fork(createCaseFromAlert, { alertIds, departmentId });
    }
  );
}
